/* eslint-disable no-undef */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-lonely-if */
// eslint-disable-next-line simple-import-sort/imports
import {
  Grid,
  IconButton,
  Theme,
  Tooltip,
  withStyles,
  Typography,
  Button,
} from '@material-ui/core';
import CircularProgressCustom from '@orientaction/components/CircularProgressCustom';
import SimpleModal from '@orientaction/components/SimpleModal';
import { cloneDeep } from 'lodash';
import { useEffect, useMemo, useRef, useState } from 'react';
import { ReactComponent as Border } from '../../../Asset/svg/border.svg';
import { ReactComponent as Check } from '../../../Asset/svg/check-3.svg';
import { ReactComponent as Deletec } from '../../../Asset/svg/deletered.svg';
import { ReactComponent as M1 } from '../../../Asset/svg/matching1.svg';
import { ReactComponent as M2 } from '../../../Asset/svg/matching2.svg';
import { ReactComponent as M3 } from '../../../Asset/svg/matching3.svg';
import { ReactComponent as M4 } from '../../../Asset/svg/matching4.svg';
import { ReactComponent as M5 } from '../../../Asset/svg/matching5.svg';
import { ReactComponent as View } from '../../../Asset/svg/view.svg';
import { ReactComponent as Warning } from '../../../Asset/svg/warning.svg';
import { useStyles } from './style';
import { apiServiceNative } from '../../../utils/fetchNative';
import { useHistory } from 'react-router-dom';
import { CloseOutlined } from '@material-ui/icons';
import { useAdminUser } from '@orientaction/hooks';
import { getFromLS } from '@orientaction/utils';

const MatchingTooltip = withStyles((theme: Theme) => ({
  tooltip: ({ backgroundColor }: { backgroundColor: string }) => ({
    backgroundColor, // Utilisation de la prop bgColor
    color: 'white',
    boxShadow: theme.shadows[1],
    fontSize: 12,
    padding: '8px 10px',
    lineHeight: 1,
  }),
}))(Tooltip);

interface IItemCandidatProps {
  dataColumns: any;
  // eslint-disable-next-line no-undef
  candidat: CandidatureTableType;
  handleIdToDelete?: (id: number) => any;
  idJob: number;
}
const ItemCandidat = ({ dataColumns, candidat, handleIdToDelete, idJob }: IItemCandidatProps) => {
  const classes = useStyles();
  const refVille = useRef(null);
  const refFirstname = useRef(null);
  const refLastname = useRef(null);
  const refEmail = useRef(null);
  const refPhonenumber = useRef(null);
  const [showTooltip, setShowTooltip] = useState<any>({});
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [openModalMatching, setOpenModalMatching] = useState<boolean>(false);
  const [showMatchingDetails, setShowMatchingDetails] = useState<boolean>(false);
  const containerRef = useRef(null);
  const dropdownRef = useRef(null);
  const [putTop, setPutTop] = useState<boolean>(false);

  const { push } = useHistory();

  const { setCurrent, setOpenDrawer, setListUphierchy } = useAdminUser();
  const currentUser = JSON.parse(getFromLS('userInfos') || '{}');

  // const MatchingTooltip = withStyles((theme: Theme) => ({
  //   tooltip: (prop: any) => ({
  //     backgroundColor: prop.bgColor, // Utilisation de la prop bgColor
  //     color: 'white',
  //     boxShadow: theme.shadows[1],
  //     fontSize: 14,
  //     padding: '8px 10px',
  //     lineHeight: 1,
  //   }),
  // }))(Tooltip);

  useEffect(() => {
    const refVilleData: any = refVille.current;
    const refFirstnameData: any = refFirstname.current;
    const refLastnameData: any = refLastname.current;
    const refEmailData: any = refEmail.current;
    const refPhonenumberData: any = refPhonenumber.current;
    let showTooltipCloned = cloneDeep(showTooltip);
    if (refVilleData) {
      showTooltipCloned = {
        ...showTooltipCloned,
        ville: refVilleData.scrollWidth > refVilleData.offsetWidth,
      };
    }
    if (refFirstnameData) {
      showTooltipCloned = {
        ...showTooltipCloned,
        firstname: refFirstnameData.scrollWidth > refFirstnameData.offsetWidth,
      };
    }
    if (refLastnameData) {
      showTooltipCloned = {
        ...showTooltipCloned,
        lastname: refLastnameData.scrollWidth > refLastnameData.offsetWidth,
      };
    }
    if (refEmailData) {
      showTooltipCloned = {
        ...showTooltipCloned,
        email: refEmailData.scrollWidth > refEmailData.offsetWidth,
      };
    }
    if (refPhonenumberData) {
      showTooltipCloned = {
        ...showTooltipCloned,
        phonenumber: refPhonenumberData.scrollWidth > refPhonenumberData.offsetWidth,
      };
    }
    setShowTooltip(showTooltipCloned);
  }, [candidat]);

  const deleteCandidat = async (id: number) => {
    if (handleIdToDelete) {
      handleIdToDelete(id);
      setOpenModal(false);
    }
  };
  const checkIfNull = (checking: number) => {
    return checking === null;
  };

  const sendMailRelance = async () => {
    try {
      const resp = await apiServiceNative.post(`/api/job/send-relance-recrutement`, {
        idJob,
        userEmail: candidat.email,
      });
      if (resp.status === 200) {
        setOpenModalMatching(false);
      }
    } catch (e) {
      setOpenModalMatching(false);
    }
  };
  const borderColor = useMemo(() => {
    const candidatureValue = candidat?.candidature?.matchingGlobal || 0;
    if (candidatureValue >= 0 && candidatureValue <= 14) {
      return '#E63C3C';
    }
    if (candidatureValue >= 15 && candidatureValue <= 29) {
      return '#FFA800';
    }
    if (candidatureValue >= 30 && candidatureValue <= 74) {
      return '#FFDC37';
    }
    if (candidatureValue >= 75 && candidatureValue <= 100) {
      return '#000A8C';
    }
  }, [candidat]);

  useEffect(() => {
    if (showMatchingDetails && containerRef.current && dropdownRef.current) {
      const containerA: any = containerRef.current;
      const dropdownA: any = dropdownRef.current;
      const containerRect = containerA.getBoundingClientRect();
      const dropdownRect = dropdownA.getBoundingClientRect();

      const spaceBelow = window.innerHeight - containerRect.bottom;
      const spaceAbove = containerRect.top;

      if (spaceBelow < dropdownRect.height && spaceAbove >= dropdownRect.height) {
        setPutTop(false);
      } else {
        setPutTop(true);
      }
    }
  }, [showMatchingDetails]);

  const handleOpen = (e: any) => {
    e.stopPropagation();
    setShowMatchingDetails(!showMatchingDetails);
  };

  const handleClickOutside = (event: any) => {
    const containerA: any = containerRef.current;
    if (containerA && !containerA.contains(event.target)) {
      setShowMatchingDetails(false);
    }
  };

  useEffect(() => {
    if (showMatchingDetails) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showMatchingDetails]);

  const onEdit = async () => {
    const { data } = await apiServiceNative.get(`/api/job/one-candidate/${candidat.idUser}`);
    setListUphierchy([
      data?.upper_hierarchy
        ? {
            ...data.upper_hierarchy,
            id: data.upper_hierarchy.id,
          }
        : null,
    ]);

    setCurrent({
      ...data,
      company: 1 as number,
      company_user_role: data.company_user_role?.id || '',
      upper_hierarchy: data.upper_hierarchy?.id || '',
      name_upper_hierarchy: `${data.upper_hierarchy?.firstname} ${data.upper_hierarchy?.lastname}`,
      isView: false,
      isUpdate: true,
    });

    setOpenDrawer(true);
  };

  const checkingMatchingData = (candidatureT: CandidatureType | undefined) => {
    return (
      candidatureT?.sensMatching &&
      candidatureT?.besoinsMatching &&
      candidatureT?.personalityMatching &&
      candidatureT?.equilibreMatching &&
      candidatureT?.talentsMatching
    );
  };

  return (
    <div className={classes.itemParent}>
      <div className={classes.itemLine} style={{ width: `calc(${dataColumns[0]} - 5px` }}>
        <div ref={refFirstname} className={classes.overflowText}>
          {candidat.firstname}
        </div>
        {showTooltip?.firstname && <div className={classes.tooltipLabel}>{candidat.firstname}</div>}
      </div>
      <div className={classes.itemLine} style={{ width: `calc(${dataColumns[1]} - 5px` }}>
        <div ref={refLastname} className={classes.overflowText}>
          {candidat.lastname}
        </div>
        {showTooltip?.lastname && <div className={classes.tooltipLabel}>{candidat.lastname}</div>}
      </div>
      <div
        className={classes.itemLine}
        style={{ width: `calc(${dataColumns[2]} - 5px`, textAlign: 'center' }}>
        <div className={classes.overflowText}>{candidat.genre}</div>
      </div>
      <div className={classes.itemLine} style={{ width: `calc(${dataColumns[3]} - 5px` }}>
        <div className={classes.overflowText}>{candidat.age}</div>
      </div>
      <div className={classes.itemLine} style={{ width: `calc(${dataColumns[4]} - 5px` }}>
        <div className={classes.overflowText}>{candidat.diplome}</div>
      </div>
      <div className={classes.itemLine} style={{ width: `calc(${dataColumns[5]} - 5px` }}>
        <div ref={refPhonenumber} className={classes.overflowText}>
          {candidat.phonenumber}
        </div>
        {showTooltip?.phonenumber && (
          <div className={classes.tooltipLabel}>{candidat.phonenumber}</div>
        )}
      </div>
      <div className={classes.itemLine} style={{ width: `calc(${dataColumns[6]} - 5px` }}>
        <div ref={refEmail} className={classes.overflowText}>
          {candidat.email}
        </div>
        {showTooltip?.email && <div className={classes.tooltipLabel}>{candidat.email}</div>}
      </div>
      <div className={classes.itemLine} style={{ width: `calc(${dataColumns[7]} - 5px` }}>
        <div ref={refVille} className={classes.overflowText}>
          {candidat.ville}
        </div>
        {showTooltip?.ville && <div className={classes.tooltipLabel}>{candidat.ville}</div>}
      </div>
      <div className={classes.itemLine} style={{ width: `calc(${dataColumns[8]} - 5px` }}>
        <div style={{ display: 'flex', alignItems: 'center', margin: '8px 0px' }}>
          <MatchingTooltip
            title="Matching Sens au travail"
            arrow={true}
            placement="top"
            backgroundColor="#74B089">
            <M1
              style={{
                marginRight: 3,
                opacity: candidat.candidature?.matchingData?.sens?.isComplete ? 1 : 0.5,
              }}
              onClick={() => !candidat.candidature?.sensMatching && setOpenModalMatching(true)}
            />
          </MatchingTooltip>
          <MatchingTooltip
            title="Matching Besoins et motivation"
            arrow={true}
            placement="top"
            backgroundColor="#B34B4B">
            <M2
              style={{
                marginRight: 3,
                opacity: candidat.candidature?.matchingData?.besoins?.isComplete ? 1 : 0.5,
              }}
              onClick={() => !candidat.candidature?.besoinsMatching && setOpenModalMatching(true)}
            />
          </MatchingTooltip>
          <MatchingTooltip
            title="Matching Personnalité"
            arrow={true}
            placement="top"
            backgroundColor="#FE5756">
            <M3
              style={{
                marginRight: 3,
                opacity: candidat.candidature?.matchingData?.personality?.isComplete ? 1 : 0.2,
              }}
              onClick={() =>
                !candidat.candidature?.personalityMatching && setOpenModalMatching(true)
              }
            />
          </MatchingTooltip>
          <MatchingTooltip
            title="Matching Talents"
            arrow={true}
            placement="top"
            backgroundColor="#BC72A7">
            <M4
              style={{
                marginRight: 3,
                opacity: candidat.candidature?.matchingData?.talents?.isComplete ? 1 : 0.5,
              }}
              onClick={() => !candidat.candidature?.talentsMatching && setOpenModalMatching(true)}
            />
          </MatchingTooltip>
          <MatchingTooltip
            title="Matching Équilibre de vie"
            arrow={true}
            placement="top"
            backgroundColor="#5B6FB6">
            <M5
              style={{
                opacity: candidat.candidature?.matchingData?.equilibre?.isComplete ? 1 : 0.5,
              }}
              onClick={() => !candidat.candidature?.equilibreMatching && setOpenModalMatching(true)}
            />
          </MatchingTooltip>
        </div>
      </div>
      <div className={classes.itemLine} style={{ width: `calc(${dataColumns[9]} - 5px` }}>
        <div className={classes.status}>
          {candidat.avancement === 'en cours' ? <Warning /> : <Check />}
          <span
            style={{
              marginLeft: 7,
              color: candidat.avancement === 'en cours' ? '#E63C3C' : '#5CCA28',
            }}>
            {candidat.avancement}
          </span>
        </div>
      </div>
      <div className={classes.itemLine} style={{ width: `calc(${dataColumns[10]} - 5px` }}>
        {checkingMatchingData(candidat?.candidature) ? (
          <Tooltip title="Cliquer pour afficher les détails" placement="top">
            <div
              ref={containerRef}
              style={{
                display: 'flex',
                justifyContent: 'center',
                position: 'relative',
                cursor: 'pointer',
              }}
              onClick={handleOpen}>
              <CircularProgressCustom
                value={Math.round(candidat.candidature?.matchingGlobal ?? 0)}
                color={borderColor}
                size={35}
                fontSize={12}
                fontSizeFloat={12}
                isPercent={true}
              />
              {showMatchingDetails && (
                <div
                  ref={dropdownRef}
                  className={classes.matchingGlobal}
                  style={{
                    top: putTop ? '105%' : undefined,
                    bottom: !putTop ? '105%' : undefined,
                  }}>
                  <Button
                    className={classes.iconBtnImageLogout}
                    style={{ background: 'transparent' }}
                    onClick={() => setShowMatchingDetails(false)}
                    endIcon={<CloseOutlined />}
                  />
                  <Typography className={classes.text}>Détails des matchings</Typography>
                  <Grid container={true}>
                    <Grid
                      lg={4}
                      item={true}
                      className={classes.gridItem}
                      style={{
                        borderTop: '1px dashed #F1F1F1',
                        borderBottom: '1px dashed #F1F1F1',
                        borderRight: '1px dashed #F1F1F1',
                      }}>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <M1 style={{ width: 30, height: 33, marginRight: 15 }} />
                        <Typography className={classes.matchTitle} style={{ color: '#74B089' }}>
                          Sens au travail
                        </Typography>
                      </div>
                      <div>
                        <CircularProgressCustom
                          value={candidat.candidature?.sensMatching || 0}
                          color="#74B089"
                          size={40}
                          fontSize={12}
                          fontSizeFloat={12}
                          isPercent={true}
                        />
                      </div>
                    </Grid>
                    <Grid
                      lg={4}
                      item={true}
                      className={classes.gridItem}
                      style={{
                        borderTop: '1px dashed #F1F1F1',
                        borderBottom: '1px dashed #F1F1F1',
                        borderRight: '1px dashed #F1F1F1',
                      }}>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <M2 style={{ width: 30, height: 33, marginRight: 15 }} />
                        <Typography className={classes.matchTitle} style={{ color: '#B34B4B' }}>
                          Besoins et motivation
                        </Typography>
                      </div>
                      <div>
                        <CircularProgressCustom
                          value={candidat.candidature?.besoinsMatching || 0}
                          color="#B34B4B"
                          size={40}
                          fontSize={12}
                          fontSizeFloat={12}
                          isPercent={true}
                        />
                      </div>
                    </Grid>
                    <Grid
                      lg={4}
                      item={true}
                      className={classes.gridItem}
                      style={{
                        borderTop: '1px dashed #F1F1F1',
                        borderBottom: '1px dashed #F1F1F1',
                      }}>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <M3 style={{ width: 30, height: 33, marginRight: 15 }} />
                        <Typography className={classes.matchTitle} style={{ color: '#FE5756' }}>
                          Personnalité
                        </Typography>
                      </div>
                      <div>
                        <CircularProgressCustom
                          value={candidat.candidature?.personalityMatching || 0}
                          color="#FE5756"
                          size={40}
                          fontSize={12}
                          fontSizeFloat={12}
                          isPercent={true}
                        />
                      </div>
                    </Grid>
                    <Grid
                      lg={6}
                      item={true}
                      className={classes.gridItem}
                      style={{
                        borderRight: '1px dashed #F1F1F1',
                      }}>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <M4 style={{ width: 30, height: 33, marginRight: 15 }} />
                        <Typography className={classes.matchTitle} style={{ color: '#BC72A7' }}>
                          Talents
                        </Typography>
                      </div>
                      <div>
                        <CircularProgressCustom
                          value={candidat.candidature?.talentsMatching || 0}
                          color="#BC72A7"
                          size={40}
                          fontSize={12}
                          fontSizeFloat={12}
                          isPercent={true}
                        />
                      </div>
                    </Grid>
                    <Grid lg={6} item={true} className={classes.gridItem}>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <M5 style={{ width: 30, height: 33, marginRight: 15 }} />
                        <Typography className={classes.matchTitle} style={{ color: '#5B6FB6' }}>
                          Équilibre de vie
                        </Typography>
                      </div>
                      <div>
                        <CircularProgressCustom
                          value={candidat.candidature?.equilibreMatching || 0}
                          color="#5B6FB6"
                          size={40}
                          fontSize={12}
                          fontSizeFloat={12}
                          isPercent={true}
                        />
                      </div>
                    </Grid>
                  </Grid>
                </div>
              )}
            </div>
          </Tooltip>
        ) : (
          ''
        )}
      </div>
      <div className={classes.itemLine} style={{ width: `calc(${dataColumns[11]} - 5px` }}>
        <div style={{ width: '100%' }}>
          <Tooltip title="Voir le candidat par rapport à l'annonce" placement="top">
            <IconButton
              aria-label="delete"
              onClick={() => push(`/admin/emploi/detail-canditat/${candidat.idCandidature}`)}>
              <View />
            </IconButton>
          </Tooltip>
          {candidat.idConsultant === currentUser.id ? (
            <Tooltip title="Modifier le candidat" placement="top">
              <IconButton aria-label="delete" onClick={onEdit}>
                <Border />
              </IconButton>
            </Tooltip>
          ) : (
            ''
          )}
          <Tooltip title="Supprimer le candidat" placement="top">
            <IconButton aria-label="delete" onClick={() => setOpenModal(true)}>
              <Deletec />
            </IconButton>
          </Tooltip>
        </div>
      </div>
      <SimpleModal
        open={openModal}
        handleClose={() => setOpenModal(false)}
        title="Information"
        message="Êtes vous sûr de vouloir supprimer ce candidat de cette annonce"
        textClick="Oui"
        textClose="Non"
        handleClick={() => deleteCandidat(candidat.idCandidature)}
      />
      <SimpleModal
        open={openModalMatching}
        handleClose={() => setOpenModalMatching(false)}
        title="Information"
        message="Souhaitez-vous relancer le candidat sur la passation de sa candidature ?"
        textClick="Oui"
        textClose="Non"
        handleClick={sendMailRelance}
      />
    </div>
  );
};
export default ItemCandidat;
